/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {BundlePositionSpecDetailModel} from './bundle-position-spec-detail.model';
import {BundlePositionSpecDetailContract} from '../../../api/contracts/bundle/bundle-position-spec-detail.contract';
import {ReferenceDataMapper} from '../../reference-data/reference-data.mapper';

export class BundlePositionSpecDetailMapper {
    static fromBundlePositionSpecDetailContract(input: BundlePositionSpecDetailContract): BundlePositionSpecDetailModel {
        let model: BundlePositionSpecDetailModel;

        if (input != null) {
            model = {
                code: input.code,
                criteriaSpecs: ReferenceDataMapper.fromReferenceDataContractArray(input.criteriaSpecs),
                valuesSpecs: ReferenceDataMapper.fromReferenceDataContractArray(input.valuesSpecs)
            };
        }
        return model;
    }
}
